import {Link} from "react-router-dom";
import {PiTicket} from "react-icons/pi";

export const LoginAnimatedButton = () => {
    return (
        <Link  to={'/login'} className="overflow-clip rounded-md flex items-center justify-center cursor-pointer">
            <div
                className="relative inline-flex items-center justify-start overflow-hidden rounded-md bg-[#9d1c1c] py-3 pl-4 pr-12 font-black uppercase tracking-[0.12em] text-white shadow transition-all duration-150 ease-in-out hover:pl-10 hover:pr-6 group"
            >
                        <span
                            className="absolute bottom-0 left-0 w-full h-0 transition-all duration-150 ease-in-out bg-white group-hover:h-full"
                        ></span>
                <span
                    className="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12"
                >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              fill="none"
                              className="w-5 h-5 text-white"
                          >
                            <path
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                                strokeWidth="2"
                                strokeLinejoin="round"
                                strokeLinecap="round"
                            ></path>
                          </svg>
                        </span>
                <span
                    className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200"
                >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              fill="none"
                              className="w-5 h-5 text-[#06130a]"
                          >
                            <path
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                                strokeWidth="2"
                                strokeLinejoin="round"
                                strokeLinecap="round"
                            ></path>
                          </svg>
                        </span>
                <span
                    className="relative w-full text-left text-sm transition-colors duration-200 ease-in-out group-hover:text-[#06130a]"
                >Sign In</span
                >
            </div>
        </Link>
    )
}

export function EventCard({
    title,
    time,
    slug,
    date,
    status,
    image,
    statusLabel,
    salesClosed = false,
}: {
    title: string,
    slug: string,
    date: string,
    time: string,
    status: boolean,
    image: string,
    statusLabel?: string,
    salesClosed?: boolean,
}) {
    return (
        <div className="w-full overflow-hidden rounded-lg border border-white/10 bg-[#0b1d10] text-white shadow-[0_24px_60px_rgba(0,0,0,0.22)]">
            <div className="h-52 w-full bg-[#3a0706]" style={{
                background: `url('${image}')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}></div>

            <div className="flex flex-col w-full p-4">
                <h2 className={'text-xl font-black uppercase leading-tight text-[#f6d98a]'}>{title}</h2>
                <p className={'mt-2 text-sm font-bold uppercase tracking-[0.12em] text-white/55'}>{date}</p>
                <div className="w-full flex flex-wrap justify-between">
                    <div className="flex flex-col gap-0 w-1/2">
                        <p className={'text-white/45'}>Time</p>
                        <div className="font-semibold text-white">{time}</div>
                    </div>

                    <div className="flex flex-col gap-0 w-1/2">
                        <p className={'text-white/45'}>Status</p>
                        <div className="font-semibold text-white">{statusLabel ?? (status ? 'Active' : 'Inactive')}</div>
                    </div>
                </div>

                <div className="flex justify-center items-center mt-3">
                    <Link to={`/event/${slug}`} className={`flex justify-center items-center gap-2 p-2 py-3 text-white w-full rounded-md font-black uppercase tracking-[0.12em] transition ${salesClosed ? 'bg-gray-400 hover:bg-gray-400' : 'bg-[#9d1c1c] hover:bg-[#b52a2a]'}`}>
                        <PiTicket /> {salesClosed ? 'Sales Closed' : 'Book Ticket'}
                    </Link>
                </div>
            </div>
        </div>
    )
}

export function PastEventCard({title, time, slug, date, status, image}: { title: string, slug: string, date: string, time: string, status: boolean, image: string }) {
    return (
        <div className="w-full overflow-hidden rounded-lg border border-gray-200 bg-white text-black">
            <div className="h-44 w-full bg-yellow-600" style={{
                background: `url('${image}')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}></div>

            <div className="flex flex-col w-full p-4">
                <h2 className={'font-bold text-lg'}>{title}</h2>
                <p className={'text-gray-400'}>{date}</p>
                <div className="w-full flex flex-wrap justify-between">
                    <div className="flex flex-col gap-0 w-1/2">
                        <p className={'text-gray-400'}>Time</p>
                        <div className="font-semibold">{time}</div>
                    </div>

                    <div className="flex flex-col gap-0 w-1/2">
                        <p className={'text-gray-400'}>Status</p>
                        <div className="font-semibold">{status ? 'Active' : 'Inactive'}</div>
                    </div>
                </div>

                <div className="flex justify-center items-center mt-3">
                    <Link to={`/event/past/${slug}`} className={'bg-primary flex justify-center items-center gap-2 p-2 py-3 text-white w-full rounded-md'}>
                        <PiTicket /> Details
                    </Link>
                </div>
            </div>
        </div>
    )
}
